import { Component, OnInit } from '@angular/core';

import { MessageService} from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmPasswordValidator } from "../../../shared/validators";
import { ILoginDetails, IResetPassword } from '../../models';
import { UserService } from '../../services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PasswordValidator } from '../../../users/components/new-user-change-password/password.validator';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
  providers: [MessageService]
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  userId;
  code;
  userName
  saveModal: boolean = false;
  constructor(
    private _formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this._route.queryParams.subscribe(params => {
      this.userId = params['userId'];
      this.code = params['code'];
    });
    
    this.resetPasswordForm = this._formBuilder.group({
      password: new FormControl("", [Validators.compose([
        Validators.required,
        PasswordValidator.patternValidator(/\d/, {
          hasNumber: true
        }),
        PasswordValidator.patternValidator(/[A-Z]/, {
          hasCapitalCase: true
        }),
        PasswordValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
        PasswordValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
          {
            hasSpecialCharacters: true
          }
        ),
        Validators.minLength(8)
      ])]),
      confirmPassword: ['', [Validators.required]]
    },{ validators: [ConfirmPasswordValidator("password", "confirmPassword")]});
  }

  public errorHandling = (control: string, error: string) => {
    return this.resetPasswordForm.controls[control].hasError(error);
  }
  get resetPasswordFormControl() {
    return this.resetPasswordForm.controls;
  }

  resetPassword({value}: {value:IResetPassword}): void {
    value.userId = this.userId;
    value.token = this.code;
    this._userService.resetPassword(value).subscribe((data:any) => {
      this.userName= data.userName;
      if(data.message =='New Password must not be your Old Password')
      {
        this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You cannot reuse the Old Password'});
      }
      else
       {
         this.messageService.add({severity:'success', summary:'Confirmed', detail:'Your Password has been reset'});
         this.saveRedirect();
       
       }
      
    });
   
  }
  saveRedirect() {
    setTimeout(() => {
      this.spinner.show();
      setTimeout(() => {
        this.spinner.hide();
      }, 2000);
      this._router.navigate(['/login']);
    }, 1000);
  }
  notAllowAmbersand($event) {
    let regex: RegExp = new RegExp(/^[^&\v]*$/g);
    let specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowRight', 'ArrowLeft'];
    if (specialKeys.indexOf($event.key) !== -1) {
      return;
    } else {
      if (regex.test($event.key)) {
        return true;
      } else {
        return false;
      }
    }
  }
}
